import { createAction, createReducer } from '@reduxjs/toolkit';
import {
  IAction,
  IActionPartner,
  IPeriodoUltimos12Meses,
  IPeriodoUltimos12MesesParnter,
} from './interfaces/apiInterfaces';
import { IInitialState, ILastTwelveMonths } from './interfaces/reduxInterfaces';

const INITIAL_STATE: IInitialState = {
  isActive: false,
  isLoading: false,
  gotSuccess: false,
  gotError: false,
  partner: false,
  dateSearch: {
    start: '',
    end: '',
  },
  tevSent: {
    value: 0,
    quantity: 0,
  },
  tevReceived: {
    value: 0,
    quantity: 0,
  },
  lastTwelveMonths: [],
};

export const getTevFaresFromApi = createAction(
  '@faresApp/tevFares/GET_TEV_FARES_FROM_API'
);

export const gotTevFaresFromApi = createAction<any>(
  '@faresApp/tevFares/GOT_TEV_FARES_FROM_API'
);

export const gotTevFaresPartnerFromApi = createAction<any>(
  '@faresApp/tevFares/GOT_TEV_FARES_PARTNER_FROM_API'
);

export const gotErrorFromTevFaresApi = createAction(
  '@faresApp/tevFares/GOT_ERROR_FROM_TEV_FARES_API'
);

export const displayTevFares = createAction<boolean>(
  '@faresApp/tevFares/DISPLAY_TEV_FARES'
);

export const logoutTevFaresApp = createAction(
  '@faresApp/tevFares/LOGOUT_TEV_FARES_APP'
);

const tevFaresReducer = createReducer(INITIAL_STATE, {
  [getTevFaresFromApi.type]: (state) => ({
    ...state,
    isActive: false,
    isLoading: true,
    gotSuccess: false,
    gotError: false,
    partner: false,
  }),
  [gotTevFaresPartnerFromApi.type]: (state, action: IActionPartner) => ({
    ...state,
    isActive: true,
    gotSuccess: true,
    gotError: false,
    isLoading: false,
    partner: true,
    dateSearch: {
      start: action.payload.data_pesquisa.de,
      end: action.payload.data_pesquisa.ate,
    },
    tevSent: {
      value: action.payload.tev_enviada.valor,
      quantity: action.payload.tev_enviada.quantidade,
    },
    tevReceived: {
      value: action.payload.tev_recebida.valor,
      quantity: action.payload.tev_recebida.quantidade,
    },
    lastTwelveMonths: action.payload.periodo.map(
      (mes: IPeriodoUltimos12MesesParnter) => {
        const data: ILastTwelveMonths = {
          date: mes.data,
          faresPassedOn: {
            value: mes.tev_enviada.valor,
            quantity: mes.tev_enviada.quantidade,
          },
          faresReceived: {
            value: mes.tev_recebida.valor,
            quantity: mes.tev_recebida.quantidade,
          },
        };
        return data;
      }
    ),
  }),
  [gotTevFaresFromApi.type]: (state, action: IAction) => ({
    ...state,
    isActive: true,
    gotSuccess: true,
    gotError: false,
    isLoading: false,
    partner: false,
    dateSearch: {
      start: action.payload.data_pesquisa.de,
      end: action.payload.data_pesquisa.ate,
    },
    tevSent: {
      value: action.payload.fiducia_clientes_enviadas.valor,
      quantity: action.payload.fiducia_clientes_enviadas.quantidade,
    },
    tevReceived: {
      value: action.payload.fiducia_wl_recebidos.valor,
      quantity: action.payload.fiducia_wl_recebidos.quantidade,
    },
    lastTwelveMonths: action.payload.periodo.map(
      (mes: IPeriodoUltimos12Meses) => {
        const data: ILastTwelveMonths = {
          date: mes.data,
          faresPassedOn: {
            value: mes.fiducia_clientes_enviadas.valor,
            quantity: mes.fiducia_clientes_enviadas.quantidade,
          },
          faresReceived: {
            value: mes.fiducia_wl_recebidos.valor,
            quantity: mes.fiducia_wl_recebidos.quantidade,
          },
        };
        return data;
      }
    ),
  }),
  [gotErrorFromTevFaresApi.type]: (state: IInitialState) => ({
    ...state,
    isActive: false,
    isLoading: false,
    gotSuccess: false,
    gotError: true,
    partner: false,
  }),
  [displayTevFares.type]: (state: IInitialState, action) => ({
    ...state,
    isActive: action.payload,
  }),
  [logoutTevFaresApp.type]: (state: IInitialState) => ({
    ...state,
    isActive: false,
    isLoading: false,
    gotSuccess: false,
    gotError: false,
    partner: false,
    dateSearch: {
      start: '',
      end: '',
    },
  }),
});

export default tevFaresReducer;
